export default __webpack_public_path__ + "static/ithealthcare-background-995a33919ce933a1dc27ebd97f65771c.jpg";